module.exports = __webpack_public_path__ + "static/assets/7a4510ab192e5a0bd0b1186db1396bce.svg";